import React, { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const CONSENT_KEY = "cortoviral_ads_consent"; // "yes" | "no"

let injected = false;

// Inserta el código de Monetag tal cual lo da su panel (los <script> hay que recrearlos para que se ejecuten)
function injectAdsHtml(html) {
  if (injected || !html) return;
  injected = true;
  const tpl = document.createElement("template");
  tpl.innerHTML = html;
  Array.from(tpl.content.childNodes).forEach((node) => {
    if (node.nodeName === "SCRIPT") {
      const s = document.createElement("script");
      Array.from(node.attributes).forEach((a) => s.setAttribute(a.name, a.value));
      s.text = node.textContent;
      document.body.appendChild(s);
    } else if (node.nodeType === 1) {
      document.body.appendChild(node.cloneNode(true));
    }
  });
}

function readConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    return null;
  }
}

export function resetAdsConsent() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (e) {}
  window.location.reload();
}

// user: null = cargando, false = sin sesión, objeto = con sesión
export const AdsLoader = ({ user }) => {
  const [ads, setAds] = useState(null);
  const [consent, setConsent] = useState(readConsent());

  useEffect(() => {
    if (user === null || injected) return;
    const token = localStorage.getItem("cortoviral_token");
    const headers = token && user ? { Authorization: `Bearer ${token}` } : {};
    axios
      .get(`${API}/ads`, { headers, withCredentials: true })
      .then((res) => setAds(res.data))
      .catch(() => setAds(null));
  }, [user?.id, user?.has_paid, user === false]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (ads?.enabled && consent === "yes") injectAdsHtml(ads.html);
  }, [ads, consent]);

  const decide = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch (e) {}
    setConsent(value);
  };

  if (!ads?.enabled || consent) return null;

  return (
    <div
      data-testid="ads-consent-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#12141D]/95 backdrop-blur border-t border-white/10 px-4 py-3"
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 text-xs text-slate-300">
        <p className="flex-1">
          La versión gratuita de CortoViral se mantiene con anuncios de Monetag, que usan cookies para mostrarlos y medirlos.
          ¿Aceptas? Puedes cambiarlo cuando quieras. Más información en la{" "}
          <a href="/privacidad#anuncios" target="_blank" rel="noopener noreferrer" className="text-red-400 underline">
            política de privacidad
          </a>
          .
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button
            data-testid="ads-consent-reject"
            onClick={() => decide("no")}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-white font-semibold border border-white/10"
          >
            Rechazar
          </button>
          <button
            data-testid="ads-consent-accept"
            onClick={() => decide("yes")}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-white font-semibold border border-white/10"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};
